import { render, staticRenderFns } from "./privacy-policy.vue?vue&type=template&id=2db32a48&scoped=true&"
import script from "./privacy-policy.vue?vue&type=script&lang=js&"
export * from "./privacy-policy.vue?vue&type=script&lang=js&"
import style0 from "./privacy-policy.vue?vue&type=style&index=0&id=2db32a48&lang=less&scoped=true&"
import style1 from "./privacy-policy.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db32a48",
  null
  
)

export default component.exports